import { LandingTranslationType } from "../../features/landing.types";

export const landing: LandingTranslationType = {
  landing: {
    hero: {
      title: "Créez votre histoire avec l'IA",
      subtitle: "Là où l'imagination rencontre l'intelligence artificielle",
      description: "Utilisez notre plateforme interactive de narration assistée par IA pour créer des histoires et des personnages captivants",
      startStory: "Commencez votre histoire",
      signIn: "Se connecter"
    },
    features: {
      title: "Libérez votre créativité",
      aiPowered: {
        title: "Histoires propulsées par l'IA",
        description: "Créez des récits uniques avec notre moteur de narration IA avancé"
      },
      interactiveChoices: {
        title: "Choix interactifs",
        description: "Façonnez votre histoire à travers des décisions significatives et des actions personnalisées"
      },
      creativeFreedom: {
        title: "Liberté créative",
        description: "Écrivez votre propre chemin avec des possibilités créatives illimitées"
      }
    },
    preview: {
      title: "Aperçu d'une histoire",
      storyText: "La porte ancienne s'ouvrit en grinçant, révélant une chambre baignée de lumière bleue éthérée. Des formations cristallines jaillissaient des murs, leurs surfaces réfléchissant d'innombrables petits arcs-en-ciel à travers la pièce. Au centre, flottant à quelques centimètres au-dessus d'un piédestal de marbre noir, se trouvait un livre relié dans ce qui semblait être de la lumière stellaire...",
      whatToDo: "Que faites-vous ?",
      choice1: "Approcher le livre avec prudence, en examinant la pièce à la recherche de pièges",
      choice2: "Utiliser votre magie pour détecter d'éventuels enchantements dangereux",
      choice3: "Saisir hardiment le livre - la fortune sourit aux audacieux !"
    },
    storyPreview: {
      header: "Découvrez une Narration Immersive",
      description: "Créez, explorez et façonnez des histoires dans un environnement interactif dynamique avec {{appName}}",
      genres: "Genres",
      themes: "Thèmes",
      environment: "Environnement",
      writeResponse: "Écrivez votre propre réponse...",
      previousStory: "Histoire précédente",
      nextStory: "Histoire suivante",
      goToStory: "Aller à l'histoire {{number}}"
    },
    callToAction: {
      title: "Prêt à commencer votre voyage ?",
      subtitle: "Rejoignez des milliers de conteurs créant des aventures uniques avec l'IA",
      button: "Commencez à écrire maintenant"
    },
    creativeSuite: {
      title: "Suite Créative",
      description: "Des outils puissants pour débloquer votre potentiel narratif et donner vie à votre imagination",
      categories: {
        stories: "Histoires",
        characters: "Personnages",
        premium: "Premium"
      },
      premiumFeature: "Fonctionnalité Premium",
      basicFeature: "Disponible dans le Plan de Base",
      freeFeature: "Gratuit pour Tous",
      getStarted: "Commencer",
      noCreditCard: "Aucune carte de crédit requise pour commencer votre parcours créatif",
      tools: {
        aiWriting: {
          title: "Écriture Assistée par IA",
          description: "Créez des histoires où vous êtes le héros avec une IA avancée. Progressez avec des réponses suggérées ou écrivez les vôtres."
        },
        genresThemes: {
          title: "Genres, Thèmes et Environnements Étendus",
          description: "En tant qu'utilisateur gratuit, accédez à un ensemble limité de genres, ou débloquez tous les genres et thèmes avec le plan de Base."
        },
        sequels: {
          title: "Suites et Séries d'Histoires",
          description: "Continuez vos meilleures histoires avec des suites et construisez des séries d'histoires captivantes."
        },
        characterBuilder: {
          title: "Créateur de Personnages",
          description: "Concevez des personnages complexes avec des personnalités détaillées, des motivations et des histoires de fond."
        },
        aiPortraits: {
          title: "Portraits de Personnages par IA",
          description: "Générez des représentations visuelles uniques de vos personnages avec notre générateur de portraits par IA."
        },
        characterExtract: {
          title: "Extraction de Personnages",
          description: "Extrayez automatiquement des personnages de vos histoires pour construire votre bibliothèque de personnages."
        },
        sharing: {
          title: "Partage et Publication d'Histoires",
          description: "Partagez vos histoires et rendez-les publiques pour que d'autres puissent les apprécier."
        },
        unlimitedStorage: {
          title: "Limite d'Histoires Augmentée",
          description: "Créez jusqu'à 5 histoires par jour avec le plan Gratuit, 25 avec le plan de Base, ou des histoires illimitées avec Premium."
        },
        statsBadges: {
          title: "Statistiques et Badges",
          description: "Suivez vos statistiques d'écriture et gagnez des badges pour vos réalisations narratives."
        }
      }
    },
    exampleStories: {
      dragonsRiddle: {
        title: "L'Énigme du Dragon",
        excerpt: "L'ancien dragon posa une énigme qui était restée insoluble pendant des siècles. \"Réponds correctement\", gronda-t-il, \"et je t'accorderai le passage à travers la montagne.\" Les écailles de l'immense créature luisaient comme de l'obsidienne dans la lumière tamisée de la caverne. Je me tenais là, les doigts tremblant contre la pierre froide, mes compagnons figés derrière moi. Les yeux ambrés du dragon se fixèrent sur les miens. \"Mais si tu échoues\", poursuivit la bête, \"tu rejoindras les os de ceux qui sont venus avant.\" Il désigna des restes épars que j'avais essayé de ne pas remarquer. Les dragons aimaient les jeux de mots et les significations cachées. Le destin de notre quête dépendait de ma capacité à déchiffrer l'énigme de la créature.",
        suggestion1: "\"La réponse est 'le temps' - il dévore tout, mais n'est jamais lui-même consommé\", proclamai-je avec plus d'assurance que je n'en ressentais.",
        suggestion2: "Je m'inclinai respectueusement devant l'ancienne bête. \"Grand dragon, puis-je vous demander une précision sur votre énigme ?\"",
        suggestion3: "Je regardai les visages effrayés de mes compagnons avant de me retourner vers le dragon. \"Peut-être pourrions-nous négocier un autre passage ?\""
      },
      echoesFromTomorrow: {
        title: "Échos du Futur",
        excerpt: "Dr. Miranda Chen fixait le message sur son écran. Il était arrivé hier, mais l'horodatage indiquait qu'il avait été envoyé demain. Elle le relut : \"Protocole Oméga initié. NE PAS poursuivre la séquence de test. Effondrement temporel catastrophique imminent.\" Miranda vérifia le dispositif de communication quantique qu'elle avait conçu - il était censé réduire la latence du signal, pas percer le voile entre maintenant et demain. Les signatures quantiques intégrées dans le message correspondaient exactement à leurs protocoles de cryptage, avec une anomalie impossible : elles présentaient des modèles de dégradation qui ne pouvaient pas encore exister. Alors que son terminal sonnait avec un autre message entrant, Miranda sentit un frisson. L'identifiant de l'expéditeur affichait son propre nom.",
        suggestion1: "Miranda tapa rapidement : \"Ici Dr. Chen. Identifiez-vous et expliquez comment vous accédez à nos systèmes sécurisés.\"",
        suggestion2: "Elle initia un arrêt d'urgence tout en sauvegardant toutes les données du projet sur le serveur hors site sécurisé.",
        suggestion3: "Elle appela son partenaire de recherche : \"Kenji, quelque chose d'impossible se passe avec le réseau quantique.\""
      },
      forgottenLibrary: {
        title: "La Bibliothèque Oubliée",
        excerpt: "La bibliothèque n'apparaissait que les nuits pluvieuses, ses portes s'ouvrant à ceux qui avaient le plus besoin de réponses. Je la cherchais depuis des années, suivant rumeurs et références obscures. Maintenant, alors que je me tenais devant son architecture impossible - plus grande à l'intérieur qu'à l'extérieur - j'hésitai. Les immenses portes en chêne étaient légèrement entrouvertes, la lumière chaude se déversant sur les pavés mouillés. Le hall d'entrée s'élevait incroyablement haut, les étagères s'étendant au-delà de l'endroit où devrait se trouver le plafond. L'air sentait le papier, l'encre et quelque chose de plus ancien - comme si le temps lui-même avait une odeur. Je remarquai que les chuchotements devenaient plus forts, provenant de milliers de livres parlant tous en même temps. Puis, une voix s'éleva au-dessus des autres : \"Nous t'attendions.\"",
        suggestion1: "\"Qui est là ?\" m'écriai-je, ma voix résonnant à travers l'espace caverneux tandis que je scrutais les allées ombragées.",
        suggestion2: "Je m'approchai de l'étagère la plus proche et fis courir mes doigts le long des dos anciens, me demandant quel livre avait parlé.",
        suggestion3: "\"Je suis venu chercher des informations sur la Convergence Céleste,\" annonçai-je à la bibliothèque chuchotante."
      }
    }
  }
};
